import React from "react";
import { color as d3Color } from "d3-color";
import { Button } from "@material-ui/core";

import { emphasize } from "@material-ui/core/styles/colorManipulator";

import { withStyles } from "@material-ui/core/styles";

const LegendChip = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
  text: {
    "&:hover, &:focus": {
      backgroundColor: ({ legendcolor }) => emphasize(legendcolor, 0.08),
    },
    backgroundColor: ({ legendcolor }) => legendcolor,
    border: ({ legendcolor }) => `1px solid ${legendcolor}`,
  },
  outlined: {
    border: ({ legendcolor }) => `1px solid ${legendcolor}`,
    // "&$disabled": {
    //   border: `1px solid ${theme.palette.action.disabledBackground}`,
    // },
  },
}))(Button);

export default function LegendItem({
  label,
  color,
  onClick,
  disabled = false,
}) {
  return (
    <LegendChip
      legendcolor={d3Color(color).copy({ opacity: 0.6 }).formatRgb()}
      onClick={onClick}
      variant={disabled ? "outlined" : "text"}
      size="small"
    >
      {label}
    </LegendChip>
  );
}
